export default "__VITE_ASSET__pZB6jf7r__"